import { Api } from '@monorepo/shared/apiClient';
import {
  invalidateWorkflowCache,
  WorkflowCacheEvents,
} from '@monorepo/shared/cacheRegisters/data2/workflowCacheRegister';
import { MutationConfig, useMutation } from 'react-query';

type UseWorkflowDeleteParams = {
  config?: MutationConfig<void, Api.ErrorResponse>;
};
export const useWorkflowDelete = (params: UseWorkflowDeleteParams) =>
  useMutation(Api.deleteWorkflow, {
    ...params?.config,
    onSuccess: (_, mutationFuncParams) => {
      const { organizationId, workflowId } = mutationFuncParams;
      const keyParams = { organizationId, workflowId };

      invalidateWorkflowCache(WorkflowCacheEvents.DELETE, keyParams);

      return params?.config?.onSuccess?.(undefined, mutationFuncParams);
    },
  });
